module.exports = __webpack_public_path__ + "static/media/lambo.5feb74a3.png";